<template>
    <div class="relative">
        <slot></slot>
        <svg width="49" height="63" viewBox="0 0 49 63" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.29041 2.5097H43.6584C45.3152 2.5097 46.6474 3.8528 46.6338 5.5096L46.6092 8.50977H48.6092L48.6338 5.5096C48.6564 2.74827 46.4362 0.509766 43.6748 0.509766H5.30681C2.54539 0.509766 0.288448 2.74827 0.265796 5.5096L0.0392343 33.1282C0.0165825 35.8895 2.2368 38.128 4.99822 38.128H43.3662C46.1276 38.128 48.3846 35.8895 48.4072 33.1282L48.426 30.8394H46.426L46.4072 33.1282C46.3936 34.785 45.0394 36.1281 43.3826 36.1281H5.01463C3.35777 36.1281 2.02564 34.785 2.03923 33.1282L2.2658 5.5096C2.27939 3.8528 3.63355 2.5097 5.29041 2.5097Z"
                fill="#031837"
            />
            <rect width="1.55783" height="26.0541" transform="matrix(1 0 -0.00820296 0.999966 23.3086 36.5918)" fill="#031837" />
        </svg>
    </div>
</template>

<script>
export default {};
</script>
